import { render, staticRenderFns } from "./SideNavigator.vue?vue&type=template&id=3ac8b3b4&"
import script from "./SideNavigator.vue?vue&type=script&lang=js&"
export * from "./SideNavigator.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigator.vue?vue&type=style&index=0&id=3ac8b3b4&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports